<script lang="ts">
</script>

<svg
	width="93"
	height="48"
	viewBox="0 0 93 48"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class="svg-fill"
>
	<path
		d="M65.1689 26.2253C70.1669 26.2253 74.3963 21.9958 74.3963 16.9979C74.3963 11.9999 70.1669 7.77051 65.1689 7.77051C60.171 7.77051 55.9415 11.9999 55.9415 16.9979C55.9415 21.9958 60.171 26.2253 65.1689 26.2253ZM67.0915 12.1917C67.6682 11.615 69.2059 11.9993 70.5518 13.3452C71.8977 14.6911 72.2819 16.0363 71.7052 16.8054C71.1285 17.5746 69.5908 16.9979 68.2449 15.652C66.8991 14.3061 66.3223 12.9609 67.0915 12.1917Z"
		fill=""
	/>
	<path
		d="M65.1695 33.914C74.5894 33.914 82.0869 26.4167 82.0869 16.9965C82.0869 7.57669 74.5897 0.0791016 65.1695 0.0791016C55.7493 0.0791016 48.2521 7.57636 48.2521 16.9965C48.2521 26.4164 55.9418 33.914 65.1695 33.914ZM65.1695 3.92495C72.4743 3.92495 78.2414 9.88452 78.2414 16.9969C78.2414 24.1099 72.2818 30.0688 65.1695 30.0688C58.0565 30.0688 52.0976 24.1092 52.0976 16.9969C52.0976 9.88452 58.0565 3.92495 65.1695 3.92495Z"
		fill=""
	/>
	<path
		d="M86.5072 8.34766H84.0079C85.1614 11.0388 85.9305 13.9223 85.9305 16.9983C85.9305 28.5326 76.7031 37.76 65.1689 37.76C53.6347 37.76 44.4073 28.5326 44.4073 16.9983C44.4073 13.9223 44.984 11.0388 46.3299 8.34766H5.76724C2.49943 8.34766 0.00012207 10.847 0.00012207 14.1148V38.1439C0.00012207 41.4117 2.49943 43.911 5.76724 43.911H12.3035V47.1788H20.9542V43.911H71.3209V47.1788H79.9716V43.911H86.5072C89.7751 43.911 92.2744 41.4117 92.2744 38.1439V14.1148C92.2744 11.0388 89.7751 8.34766 86.5072 8.34766ZM11.1508 36.0298C11.1508 37.1833 10.3816 37.9524 9.22817 37.9524C8.07475 37.9524 7.30558 37.1833 7.30558 36.0298V16.4216C7.30558 15.2682 8.07475 14.499 9.22817 14.499C10.3816 14.499 11.1508 15.2682 11.1508 16.4216V36.0298ZM19.9932 36.0298C19.9932 37.1833 19.2241 37.9524 18.0706 37.9524C16.9172 37.9524 16.1481 37.1833 16.1481 36.0298L16.1487 16.4216C16.1487 15.2682 16.9179 14.499 18.0713 14.499C19.2247 14.499 19.9939 15.2682 19.9939 16.4216L19.9932 36.0298ZM28.8364 36.0298C28.8364 37.1833 28.0672 37.9524 26.9138 37.9524C25.7604 37.9524 24.9912 37.1833 24.9912 36.0298L24.9918 16.4216C24.9918 15.2682 25.761 14.499 26.9144 14.499C28.0679 14.499 28.837 15.2682 28.837 16.4216L28.8364 36.0298Z"
		fill=""
	/>
</svg>

<style>
</style>
